import { Alert, Button, Link, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const CompleteForeignUpload: React.FC = () => {
  const { t } = useTranslation('pages.signUp.form.completeForeignUpload');

  return (
    <Stack flex={1} w="100%" h="100%" align="center" gap={{ base: 6, lg: 10 }}>
      <Alert w="max-content" color="text" status="success">
        {t('uploadHasBeenSuccessfully')}
      </Alert>
      <Stack>
        <Text textAlign="center">{t('checkWithTicket')}</Text>
      </Stack>
      <Stack w="100%" align="center" mt="auto" mb={{ base: 0, lg: 20 }}>
        <Button colorScheme="secondary" as={Link} href={routes.signIn.url}>
          {t('goToMainPage')}
        </Button>
      </Stack>
    </Stack>
  );
};

export default CompleteForeignUpload;
